import { ContactAddressField, ContactNameFields } from "@portal/components/features/contact-forms";
import { FormField, FormFieldGroup, FormItemLabel, FormRow } from "@portal/components/form";
import { FormInput, FormSSN, FormYesNo } from "@portal/components/form/fields";
import { Button } from "@portal/components/primitives";
import { UseFormReturn } from "react-hook-form";
import { UseAddressValidationReturn } from "../../../../../api";
import { AdminIndividualOwnerFormData, DefaultAdminIndividualFormData } from ".";

type AdminIndividualOwnerFormProps = {
	form: UseFormReturn<DefaultAdminIndividualFormData, any, AdminIndividualOwnerFormData>;
	addressValidation: UseAddressValidationReturn;
	onSubmit: (data: AdminIndividualOwnerFormData) => void;
	loading: boolean;
};

export const AdminIndividualForm = ({
	form,
	addressValidation,
	onSubmit,
	loading,
}: AdminIndividualOwnerFormProps) => {
	const includeInUnderwriting = form.watch("includeInUnderwriting");
	const ownerMarried = form.watch("married");

	const handleSubmit = (formData: AdminIndividualOwnerFormData) => {
		onSubmit(formData);
	};

	return (
		<form className="w-full h-fit flex flex-col space-y-[25px]">
			<FormFieldGroup condensed>
				<FormRow className="justify-start gap-x-[40px]">
					<FormField className="max-w-fit">
						<FormItemLabel condensed required>
							Include in underwriting?
						</FormItemLabel>
						<FormYesNo name="includeInUnderwriting" control={form.control} compact />
					</FormField>
					<FormField className="max-w-fit">
						<FormItemLabel condensed required>
							Include in indemnity?
						</FormItemLabel>
						<FormYesNo name="includeInIndemnity" control={form.control} compact />
					</FormField>
				</FormRow>
				<ContactNameFields control={form.control} compact />
				<ContactAddressField
					formMethods={form}
					addressControl={addressValidation.addressFieldControl}
					compact
				/>
				<FormRow>
					<FormField condensed>
						<FormItemLabel condensed>
							Email
							<span className="text-gray-400 text-[13px] ml-[8px] font-normal">If Available</span>
						</FormItemLabel>
						<FormInput name="email" control={form.control} compact />
					</FormField>
					{includeInUnderwriting && (
						<FormField className="max-w-[200px]" condensed>
							<FormItemLabel condensed>SSN</FormItemLabel>
							<FormSSN name="ssn" control={form.control} compact />
						</FormField>
					)}
				</FormRow>
			</FormFieldGroup>
			<FormRow className="justify-start gap-x-[40px]">
				<FormField className="max-w-fit">
					<FormItemLabel>Does this individual own a home?</FormItemLabel>
					<FormYesNo name="ownsAHome" control={form.control} compact />
				</FormField>
				<FormField className="max-w-fit">
					<FormItemLabel>Is this individual married?</FormItemLabel>
					<FormYesNo name="married" control={form.control} compact />
				</FormField>
			</FormRow>
			<div className="w-full flex justify-center mt-[5px]">
				<Button
					onClick={form.handleSubmit(handleSubmit)}
					color="primary"
					className="w-[150px] h-[36px]"
					tabIndex={2}
					loading={form.formState.isSubmitting || loading}
				>
					{ownerMarried ? "Next" : "Submit"}
				</Button>
			</div>
		</form>
	);
};
